import React from 'react';
import PropTypes from '../../utils/PropTypes';

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: 'h-6 w-6',
};

const CloudIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.54833 31.6665C3.66833 31.6665 0 27.2498 0 22.4998C0 17.9965 3.25333 14.2582 7.535 13.4865C7.88833 6.9015 13.325 1.6665 20 1.6665C26.6767 1.6665 32.1117 6.9015 32.465 13.4865C36.7483 14.2582 40 17.9965 40 22.4998C40 27.3015 36.2317 31.6665 30.6333 31.6665C31.355 30.1515 31.7583 28.4548 31.7583 26.6665C31.7583 20.2282 26.53 14.9998 20.0917 14.9998C13.6517 14.9998 8.425 20.2282 8.425 26.6665C8.425 28.4548 8.82833 30.1515 9.54833 31.6665Z"
      fill="#8390EF"
    />
    <path fillRule="evenodd" clipRule="evenodd"
      d="M24.6867 33.618C23.3683 34.4897 21.79 34.9997 20.0917 34.9997C15.4917 34.9997 11.7583 31.2663 11.7583 26.6663C11.7583 22.0663 15.4917 18.333 20.0917 18.333C24.6917 18.333 28.425 22.0663 28.425 26.6663C28.425 28.3647 27.915 29.943 27.0433 31.2613L31.7583 35.9763L29.4017 38.333L24.6867 33.618ZM20.0917 21.6663C22.85 21.6663 25.0917 23.908 25.0917 26.6663C25.0917 29.4247 22.85 31.6663 20.0917 31.6663C17.3317 31.6663 15.0917 29.4247 15.0917 26.6663C15.0917 23.908 17.3317 21.6663 20.0917 21.6663Z"
      fill="#4256E7"
    />
  </svg>
);

CloudIcon.propTypes = propTypes;
CloudIcon.defaultProps = defaultProps;

export default React.memo(CloudIcon);
